import { SITE } from "@/lib/site";

// A quiet brand-mark moment used between sections. Shows the full logo
// (icon + wordmark + tagline) — the cream logo background blends into
// the bone2 page background via mix-blend-multiply.
export default function BrandMark() {
    return (
        <section
            data-testid="brand-mark-section"
            className="py-20 md:py-28 bg-bone2 relative"
            aria-label="Caring for Country mark"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="border-y border-rule py-14 md:py-20 flex flex-col items-center text-center">
                    <span className="block w-12 h-px bg-ochre mb-12" />

                    <div
                        className="relative w-56 h-56 md:w-72 md:h-72 mb-10"
                        style={{ isolation: "isolate" }}
                    >
                        <img
                            src={SITE.logo}
                            alt="Caring for Country — protecting land, culture, and climate"
                            data-testid="brand-mark-logo"
                            className="w-full h-full object-contain"
                            style={{ mixBlendMode: "multiply" }}
                        />
                    </div>

                    <p className="font-serif italic text-2xl md:text-3xl lg:text-[34px] text-ink leading-[1.2] max-w-3xl">
                        Helping systems respond
                        <br className="hidden md:block" />
                        to community priorities.
                    </p>
                    <span className="mt-8 eyebrow text-ink2">
                        {SITE.domain}
                    </span>
                    <span className="block w-12 h-px bg-ochre mt-10" />
                </div>
            </div>
        </section>
    );
}
